const HOST = window.location.host;
const API_BASE_URL = 'https://' + HOST;
const PAGE_BASE_URL = 'https://localhost:3000';

//API Service URL
export const API = {
    //공통업무(메인)
    MAIN: {
        OPER_STATIS: `${API_BASE_URL}/api/main/oper-statis`,          //대시보드-기기운영현황
        OPER: `${API_BASE_URL}/api/main/oper`,          //대시보드-기기운영현황
        CLOSE_STATIS: `${API_BASE_URL}/api/main/close-statis`,        //대시보드-당일마감현황
        CLOSE: `${API_BASE_URL}/api/main/close`,        //대시보드-당일마감현황
        TRANS: `${API_BASE_URL}/api/main/trans`,        //대시보드-거래집계현황
        CASH: `${API_BASE_URL}/api/main/cash`,          //대시보드-기기시재현황
    },
    //공통API
    COMMON: {
        BRANCH: `${API_BASE_URL}/api/cmm/branch`,        //지점정보
        MACHINE: `${API_BASE_URL}/api/cmm/bran-mach/`,      //기기번호
        TRANS_TYPE: `${API_BASE_URL}/api/cmm/trans-type`,//거래타입(공통코드)
        IN_OUT: `${API_BASE_URL}/api/cmm/in-out`,        //입출금구분(공통코드)
        CASH: `${API_BASE_URL}/api/cmm/cash`,            //시재종류
        REMOTE_CMD: `${API_BASE_URL}/api/cmm/remote-cmd`,//원격명령종류
        USER_GROUP: `${API_BASE_URL}/api/cmm/user-group`,//사용자그룹
        MODEL: `${API_BASE_URL}/api/cmm/mach-kind`,      //기종
        MENU: `${API_BASE_URL}/api/cmm/menu`,            //메뉴
        USER_NAME: `${API_BASE_URL}/api/cmm/user-name`,  //사용자이름
        BRAND: `${API_BASE_URL}/api/cmm/brand`, //브랜드정보
        PERMISSION: `${API_BASE_URL}/api/cmm/permission`, //접근권한
        CHECK_URL: `${API_BASE_URL}/api/cmm/check-url`, //URL접근확인
        UPLOAD_EXCEL: `${API_BASE_URL}/api/cmm/upload-excel`, //엑셀업로드
        BRANCH_GROUP: `${API_BASE_URL}/api/cmm/branch-group`,//지점그룹
    },
    //거래정보
    TRANS: {
        TOTAL: `${API_BASE_URL}/api/trans/total`,              //거래집계
        TOTAL_DETAIL: `${API_BASE_URL}/api/trans/total/detail`,//거래집계상세
        HIST: `${API_BASE_URL}/api/trans/hist`,                //거래내역
        HIST_JRNL: `${API_BASE_URL}/api/trans/hist/jrnl`,      //저널조회
        HIST_JRNL_IMG: `${API_BASE_URL}/api/trans/hist/jrnl/img`,      //이미지조회
    },
    //자금정보
    CASH: {
        VAULT_CNT: `${API_BASE_URL}/api/cash/vault/cnt`, //기기시재현황(수량)
        VAULT_AMT: `${API_BASE_URL}/api/cash/vault/amt`, //기기시재현황(금액)
        VAULT_HIST: `${API_BASE_URL}/api/cash/vault/hist/`,       //시재거래이력조회
        CLOSE_DAILY: `${API_BASE_URL}/api/cash/close/daily`,      //일일마감내역
        CLOSE_DAILY2: `${API_BASE_URL}/api/cash/close/daily2`,      //일일마감내역
        TOTAL: `${API_BASE_URL}/api/cash/close/total`,      //일일마감내역-total
        CLOSE_USER: `${API_BASE_URL}/api/cash/close/user`,        //사용자마감내역
        CLOSE_MACHINE: `${API_BASE_URL}/api/cash/close/daily/`,   //일일마감내역상세조회
        CLOSE_USER_DETAIL: `${API_BASE_URL}/api/cash/close/user/`,//사용자마감내역상세조회
        CLOSE_USER_DETAIL_TOTAL: `${API_BASE_URL}/api/cash/close/total/`,//사용자마감내역상세조회
        ENDDAY: `${API_BASE_URL}/api/cash/endday`,      //일일마감내역
    },
    //기기운영관리
    OPER: {
        MACHINE: `${API_BASE_URL}/api/oper/machine`,       //장비관리
        MACHINE_KEY: `${API_BASE_URL}/api/oper/machine/key`,       //장비관리
        USER: `${API_BASE_URL}/api/oper/user`,             //사용자관리
        PWD: `${API_BASE_URL}/api/oper/user/pwd`,          //비밀번호변경
        INITPWD: `${API_BASE_URL}/api/oper/user/pwd/init`, //초기비밀번호변경
        TILL: `${API_BASE_URL}/api/oper/till`,             //준비금설정
        STATUS: `${API_BASE_URL}/api/oper/status`,         //기기상태
        STATUS_MACHINE: `${API_BASE_URL}/api/oper/status/detail`,//기기상태(상태내역)
    },
    //시스템관리
    SYSTEM: {
        PROGRAM: `${API_BASE_URL}/api/system/program`,    //프로그램관리
        UPLOAD: `${API_BASE_URL}/api/system/upload`,      //파일업로드(실행)
        JARUPLOAD: `${API_BASE_URL}/api/system/JarUpload`,//jar 파일 업로드 실행
        REMOTE: `${API_BASE_URL}/api/system/remote`,      //원격제어관리
        REMOTE_DOWNLOG: `${API_BASE_URL}/api/system/remote/downloadLog`,      //원격제어관리 서버로그 다운로드
        LOG: `${API_BASE_URL}/api/system/log/`,           //로그
        MENU: `${API_BASE_URL}/api/system/menu`,          //메뉴관리
        PMENU: `${API_BASE_URL}/api/system/menu/combo`,          //메뉴콤보
        GROUP: `${API_BASE_URL}/api/system/group`,        //그룹관리
        MENU_AUTH: `${API_BASE_URL}/api/system/menu/auth`,//메뉴권한관리
        CHECK_MENU_AUTH: `${API_BASE_URL}/api/system/menu/auth/check`,//메뉴권한관리
        CODE: `${API_BASE_URL}/api/system/code`,          //공통코드관리
        MACHINE: `${API_BASE_URL}/api/system/machine`,    //기종관리
        STORE: `${API_BASE_URL}/api/system/brand`,       //브랜드관리
        BRANCH: `${API_BASE_URL}/api/system/branch`,       //지점관리
        PMS_LOG: `${API_BASE_URL}/api/system/pms-log`,       //PMS수신전문 조회
        BRANCH_GROUP: `${API_BASE_URL}/api/system/branchGroup`,       //지점관리
    },
};

//PAGE(VIEW) URL
export const PAGE = {
    //인증
    AUTH: {
        LOGIN: `/login`,        //로그인
        LOGOUT: `/logout`,        //로그아웃
        INITPWD: `/initpwd`     //최초비밀번호로그인시도
    },
    //공통업무(메인)
    MAIN: {
        DASHBOARD: `/main/dashboard`,//대시보드
        NEWDASHBOARD: `/main/newdashboard`,//대시보드
        STATUS: `/main/status`,//기기상태
    },
    //거래정보
    TRANS: {
        TOTAL: `/trans/total`,//거래집계,거래집계상세
        HIST: `/trans/hist`,  //거래내역
        HIST_POPUP: `/trans/histPopup`,//저널조회(팝업)
    },
    //자금정보
    CASH: {
        VAULT: `/cash/vault`,            //기기시재현황
        VAULT_POPUP: `/cash/vaultPopup`, //시재거래이력조회(팝업)
        CLOSE: `/cash/close`,            //일일마감내역,사용자마감내역
        CLOSE2: `/cash/close2`,            //일일마감내역,사용자마감내역
        CLOSE_DAILY_POPUP: `/cash/closeDailyPopup`,//일일마감내역상세조회
        CLOSE_USER_POPUP: `/cash/closeUserPopup`,  //사용자마감내역상세조회
        END_OF_DAY_REPORT: `/cash/report`,            //마감리포트
    },
    //기기운영관리
    OPER: {
        MACHINE: `/oper/machine`,        //장비관리
        MACHINE_MODIFY: '/oper/machineModify', //장비관리 수정삭제
        USER: `/oper/user`,      //사용자관리
        USERPWD_POPUP: `/oper/userpwdPopup`,  //비밀번호변경(팝업)
        TILL: `/oper/till`, //준비금설정
        STATUS_POPUP: `/oper/statusPopup`,//기기상태(장애내역)(팝업)
        GROUP: `/oper/group`,                 //그룹관리
    },
    //시스템관리
    SYSTEM: {
        PROGRAM: `/system/program`,             //프로그램관리
        FILEUPLOAD_POPUP: `/system/filePopup`,  //파일업로드(팝업)
        REMOTE: `/system/remote`,               //원격제어관리
        LOG_POPUP: `/system/logPopup`,          //로그(팝업)
        MENU: `/system/menu`,                   //메뉴관리
        MENUAUTH_POPUP: `/system/menuAuthPopup`,//메뉴권한관리(팝업)
        CODE: `/system/code`,                   //공통코드관리
        MACHINE: `/system/machine`,             //기종관리
        STORE: `/system/store`,
        BRANCH: `/system/branch`,                //지점관리
        PMS_LOG: `/system/pmsLog`,                //PMS수신전문 조회
        BRANCH_GROUP: `/system/branchGroup`,                //지점관리
    },
}


//AGENT 정보
export const AGENT = {
    PORT: '7711',
}

//초기 로드 화면 정보
export const DASH_INFO = {
    PAGE_NO: '0001',
    PAGE_URL: '/main/dashboard',
    P_PAGE_NO: '0000',
}

export default API_BASE_URL;